import React from "react"

import ServiceItem from "./ServiceCard"
import ServiceAccordion from "./ServiceAccordion"

import { cutInLines } from "../contentEdit"

import patternOrange from "../../assets/images/footer-pattern-orange.svg"

import { ServiceCardType } from "../../types"
import { useExpandableCard } from "./useExpandableCardHook"

type DataCurationProps = {
  title: string
  text: string
  cards: ServiceCardType[]
}

const DataCuration = ({ title, text, cards }: DataCurationProps) => {
  const {
    cardsContainer,
    closeCard,
    expandedDirection,
    isCardExpanded,
    openCard,
  } = useExpandableCard()

  const cardItems = cards?.map((card, i) => (
    <div key={`service-item-${i}`} className="col-sm-6 col-xl-4 col-xxl-3">
      <ServiceItem
        card={card}
        isExpanded={isCardExpanded(i)}
        onClick={elm => openCard(i, elm)}
        onClose={closeCard}
        expandDirection={expandedDirection}
      />
    </div>
  ))

  const mobileItems = cards?.map((card, i) => {
    return (
      <div className="col-12" key={`service-accordion-${i}`}>
        <ServiceAccordion card={card} i={i} identifierType="curation" />
      </div>
    )
  })

  return (
    <section className="c-dataCuration" id="data-curation">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xxl-10">
            <div className="row">
              <div className="col-lg-10 col-xl-8 col-xxl-6">
                <div className="c-dataCuration__box">
                  <div className="c-dataCuration__headline">
                    {cutInLines(title)}
                  </div>

                  <p className="c-dataCuration__text">{text}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="c-dataCuration__belt">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-10">
              <div className="c-dataCuration__beltBox">
                <div className="row d-none d-sm-flex" ref={cardsContainer}>
                  {cardItems}
                </div>

                <div className="row d-sm-none">{mobileItems}</div>
              </div>
            </div>
          </div>
        </div>

        <img src={patternOrange} className="c-dataCuration__pattern" alt="" />
      </div>
    </section>
  )
}

export default DataCuration
